// @flow
import React, { type Element } from 'react';
import 'react-select/dist/react-select.css';
import ReactSelect from 'react-select';
import { find, get, difference } from 'lodash';
import type { MetricCategory } from '../../../types';
import './ratingFilter.scss';

const styles = {
  h3: {
    fontSize: '1em',
    fontWeight: 600,
    marginTop: 20,
    marginBottom: 5,
    lineHeight: 1.42857143,
  },
};

const BASE_FILTERS = [
  { label: '5-Stars', value: 5 },
  { label: '4-Stars', value: 4 },
  { label: '3-Stars', value: 3 },
  { label: '2-Stars', value: 2 },
  { label: '1-Stars', value: 1 },
];

const getAnalyticsProps = (newFilters, oldFilters, counts) => {
  const filtersRemoved = difference(oldFilters, newFilters).map((starRating) => {
    const count = get(find(counts, { starRating }), 'count', 0);
    return ({
      reviewCount: count,
      FilterName: `starRating (${starRating})`,
      filterState: 'deselected',
    });
  });

  const filtersAdded = difference(newFilters, oldFilters).map((starRating) => {
    const count = get(find(counts, { starRating }), 'count', 0);
    return ({
      reviewCount: count,
      FilterName: `starRating (${starRating})`,
      filterState: 'selected',
    });
  });

  return [...filtersAdded, ...filtersRemoved][0];
};

type Props = {
  categories: MetricCategory[],
  categoryId: number,
  onSelect: (any, any) => any,
  starRatingFilters: number[],
};

export const MobileRatingFilterComponent = ({
  categories,
  categoryId,
  onSelect,
  starRatingFilters,
}: Props): Element<"section"> => {
  const counts = get(find(categories, { id: categoryId }), 'reviewMetrics.starRatingCounts', []);
  const options = BASE_FILTERS.map(({ label, value }) => {
    const count = get(find(counts, { starRating: value }), 'count', 0);
    return { value, label: `${label} (${count})`, disabled: count < 1 };
  });

  return (
    <section className="store-review_filters-pane">
      <h3 style={styles.h3}>Rating:</h3>
      <ReactSelect
        id="review-tab-star-rating-filter-mobile"
        {...{ options }}
        value={starRatingFilters}
        multi
        simpleValue
        searchable={false}
        onChange={(value) => {
          const splitValue = (value !== '') ? value.split(',') : [];
          const analyticsProps = getAnalyticsProps(splitValue, starRatingFilters, counts);
          onSelect(splitValue, analyticsProps);
        }}
      />
    </section>
  );
};

export default MobileRatingFilterComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/MobileRatingFilter.js